const Images = {
  gtd2: require("./gtd2.jpg").default,
  gtd3: require("./gtd3.jpg").default,
  gtd4: require("./gtd4.jpg").default,
  gtd5: require("./gtd5.jpg").default,
  gtd6: require("./gtd6.jpg").default,
  gtd7: require("./gtd7.jpg").default,
  gtd8: require("./gtd8.jpg").default,
  gtd9: require("./gtd9.jpg").default,
  gtd10: require("./gtd10.jpg").default,
};

export default Images;
